export default __webpack_public_path__ + "static/media/bath.b937db6b.svg";